import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
var __default__ = {
  name: "GroupEditor",
  data: function data() {
    return {
      editData: {
        name: "",
        class_id: false,
        type: "student",
        students: [],
        participants: []
      },
      keywordFilter: "",
      classroomFilter: "",
      studentsList: [],
      participantsList: [],
      dataUpdating: false,
      isLoading: {
        students: false,
        participants: false,
        editData: true
      },
      showCurrentGroup: true,
      showOnlySelected: false,
      selectedStudentCount: 0,
      selectedParticipantCount: 0,
      showCompleteModal: false,
      modalButtonDisabled: false,
      localModalSettings: {
        title: "",
        message: ""
      },
      showConfirmModal: false,
      confirmMessageTitle: "",
      confirmMessage: "",
      error: {
        name: null,
        members: null
      },
      warning: ""
    };
  },
  head: {
    title: function title() {
      return {
        inner: "グループ管理"
      };
    },
    meta: []
  },
  computed: {
    isAllSelected: function isAllSelected() {
      var _this = this;

      if (this.editData.type === "student") {
        var filteredStudentIds = this.filteredStudentsList.map(function (v) {
          return v.id;
        });
        return this.editData.students.length !== 0 && filteredStudentIds.every(function (v) {
          return _this.editData.students.includes(v);
        });
      } else {
        var filteredParticipantIds = this.filteredParticipantsList.map(function (v) {
          return v.id;
        });
        return this.editData.participants.length !== 0 && filteredParticipantIds.every(function (v) {
          return _this.editData.participants.includes(v);
        });
      }
    },
    filteredStudentsList: function filteredStudentsList() {
      var _this2 = this;

      var localStudentsList = this.studentsList;

      if (this.showOnlySelected) {
        localStudentsList = localStudentsList.filter(function (v) {
          return _this2.editData.students.includes(v.id);
        });
      }

      if (this.classroomFilter) {
        localStudentsList = localStudentsList.filter(function (v) {
          return v.class_id === _this2.classroomFilter;
        });
      }

      if (this.keywordFilter) {
        localStudentsList = localStudentsList.filter(function (v) {
          return v.name.indexOf(_this2.keywordFilter) > -1;
        });
      }

      return localStudentsList;
    },
    filteredParticipantsList: function filteredParticipantsList() {
      var _this3 = this;

      var localParticipantsList = this.participantsList;

      if (this.showOnlySelected) {
        localParticipantsList = localParticipantsList.filter(function (v) {
          return _this3.editData.participants.includes(v.id);
        });
      }

      if (this.keywordFilter) {
        localParticipantsList = localParticipantsList.filter(function (v) {
          return v.name.indexOf(_this3.keywordFilter) > -1;
        });
      }

      localParticipantsList = localParticipantsList.sort(function (a, b) {
        if (a.belonging === null && b.belonging === null) {
          if (a.ruby && b.ruby) {
            if (a.ruby < b.ruby) return -1;
            if (a.ruby > b.ruby) return 1;
          }
        }

        if (a.belonging !== null && b.belonging === null) return -1;
        if (a.belonging === null && b.belonging !== null) return 1;
        if (a.belonging < b.belonging) return -1;
        if (a.belonging > b.belonging) return 1;

        if (a.ruby && b.ruby) {
          if (a.ruby < b.ruby) return -1;
          if (a.ruby > b.ruby) return 1;
        }

        return 0;
      });
      return localParticipantsList;
    }
  },
  watch: {
    filteredStudentsList: function filteredStudentsList(val) {
      var ids = val.map(function (v) {
        return v.id;
      });

      if (this.editData.type === "student") {
        if (this.editData.students.find(function (v) {
          return !ids.includes(v);
        })) {
          this.warning = "表示されていない" + this.studentAddress + "がグループに含まれています";
        } else {
          this.warning = "";
        }
      }
    },
    filteredParticipantsList: function filteredParticipantsList(val) {
      if (this.editData.type === "participant") {
        var ids = val.map(function (v) {
          return v.id;
        });

        if (this.editData.participants.find(function (v) {
          return !ids.includes(v);
        })) {
          this.warning = "表示されていない関係者がグループに含まれています";
        } else {
          this.warning = "";
        }
      }
    },
    "editData.type": function editDataType(val) {
      if (val === "student") {
        this.selectedParticipantCount = 0;
        this.editData.participants = [];
      } else if (val === "participant") {
        this.selectedStudentCount = 0;
        this.editData.students = [];
      }
    }
  },
  created: function created() {
    var _this4 = this;

    if (this.isEditMode) {
      getData("reader/get_group_with_students/" + this.$route.params.id).then(function (data) {
        _this4.editData.name = data.items.group.name;
        _this4.editData.type = data.items.group.type;
        _this4.editData.class_id = data.items.group.class_id;
        _this4.editData.students = data.items.students;
        _this4.editData.participants = data.items.participants;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this4.isLoading.editData = false;
      });
    }

    this.getStudents();
    this.getParticipants();
  },
  methods: {
    saveData: function saveData() {
      var _this5 = this;

      var valid = true;
      this.error = {
        name: null,
        members: null
      };

      if (!this.editData.name) {
        this.error.name = "グループ名を入力してください。";
        valid = false;
      }

      if (this.editData.name.length > 20) {
        this.error.name = "グループ名を20文字以下にしてください";
        valid = false;
      }

      if (this.groups.find(function (v) {
        return v.id !== _this5.$route.params.id && v.name === _this5.editData.name;
      })) {
        this.error.name = "既存のグループと重複しています。";
        valid = false;
      }

      if (this.editData.type === "student" && this.editData.students.length === 0 || this.editData.type === "participant" && this.editData.participants.length === 0) {
        this.error.members = "選択してください。";
        valid = false;
      }

      if (!valid) {
        return;
      }

      this.dataUpdating = true;
      new Promise(function (resolve, reject) {
        if (_this5.isEditMode) {
          updateData("writer/write_group/" + _this5.$route.params.id, _this5.editData).then(function () {
            _this5.localModalSettings = {
              title: "更新完了",
              message: "グループ更新が完了しました。"
            };
            resolve();
          }).catch(function () {
            _this5.localModalSettings = {
              title: "登録失敗",
              message: "グループ登録に失敗しました。"
            };
            reject();
          });
        } else {
          createData("writer/write_group", _this5.editData).then(function () {
            _this5.localModalSettings = {
              title: "登録完了",
              message: "グループ登録が完了しました。"
            };
            resolve();
          }).catch(function () {
            _this5.localModalSettings = {
              title: "登録失敗",
              message: "グループ登録に失敗しました。"
            };
            reject();
          });
        }
      }).then(function () {
        return getData("groups");
      }).then(function (data) {
        _this5.groups = data.items;
        _this5.showCompleteModal = true;
      });
    },
    confirmDelete: function confirmDelete() {
      this.confirmMessageTitle = "グループ削除";
      this.confirmMessage = "グループを削除します。\n本当によろしいですか？";
      this.showConfirmModal = true;
    },
    cancelConfirm: function cancelConfirm() {
      this.showConfirmModal = false;
    },
    handleDeleteData: function handleDeleteData() {
      var _this6 = this;

      this.dataUpdating = true;
      this.showConfirmModal = false;
      deleteData("eraser/delete_group/" + this.$route.params.id).then(function () {
        _this6.localModalSettings = {
          title: "削除完了",
          message: "グループ削除が完了しました。"
        };
        return getData("groups");
      }).catch(function (error) {
        _this6.localModalSettings = {
          title: "削除失敗",
          message: "グループ削除に失敗しました。"
        };
        console.log(error);
      }).then(function (data) {
        _this6.groups = data.items;
        _this6.showCompleteModal = true;
      });
    },
    completeCreate: function completeCreate() {
      this.$router.push({
        name: "groups"
      });
    },
    completeRefresh: function completeRefresh() {
      this.$router.push({
        name: "groups"
      });
    },
    getStudents: function getStudents() {
      var _this7 = this;

      this.isLoading.students = true;
      this.editData.students = [];
      this.studentsList = [];
      getData("students?with[]=group" + (this.editData.class_id ? "&classrooms=" + this.editData.class_id : "")).then(function (data) {
        _this7.studentsList = data.items;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this7.isLoading.students = false;
      });
    },
    getParticipants: function getParticipants() {
      var _this8 = this;

      this.isLoading.participants = true;
      this.editData.participants = [];
      this.participantsList = [];
      getData("participants?with[]=group").then(function (data) {
        _this8.participantsList = data.items;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this8.isLoading.participants = false;
      });
    },
    getCurrentClassName: function getCurrentClassName(id) {
      var classroom = this.classrooms.filter(function (v) {
        return v.id === id;
      })[0];
      return classroom ? classroom.name : "";
    },
    changeAll: function changeAll(e) {
      if (e.target.checked) {
        if (this.editData.type === "student") {
          this.editData.students = this.filteredStudentsList.map(function (v) {
            return v.id;
          });
        } else if (this.editData.type === "participant") {
          this.editData.participants = this.filteredParticipantsList.map(function (v) {
            return v.id;
          });
        }
      } else if (!e.target.checked) {
        if (this.editData.type === "student") {
          this.editData.students = [];
        } else if (this.editData.type === "participant") {
          this.editData.participants = [];
        }
      }
    }
  }
};
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useStore } from "vue2-helpers/vuex";
import { createData, deleteData, getData, updateData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage";
import MessageModal from "@/components/common/MessageModal.vue";
import ConfirmModal from "@/components/common/ConfirmModal";
import RowItem from "@/components/RowItem";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useGroupStore } from "@/stores/group";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _storeToRefs = storeToRefs(useGroupStore()),
        groups = _storeToRefs.groups;

    var _storeToRefs2 = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs2.classrooms;

    var route = useRoute();
    var store = useStore();
    var studentAddress = computed(function () {
      return store.state.studentAddress;
    });
    var grades = computed(function () {
      return store.state.grades;
    });
    var isEditMode = computed(function () {
      return route.params.id;
    });
    expose({
      groups: groups,
      classrooms: classrooms,
      isEditMode: isEditMode,
      studentAddress: studentAddress,
      grades: grades
    });
    return {
      __sfc: true,
      groups: groups,
      classrooms: classrooms,
      route: route,
      store: store,
      studentAddress: studentAddress,
      grades: grades,
      isEditMode: isEditMode,
      LoadingMessage: LoadingMessage,
      MessageModal: MessageModal,
      ConfirmModal: ConfirmModal,
      RowItem: RowItem
    };
  }
});